import { Router } from 'expo-router';

import { routes } from 'utils/routing';

import { UnavailableOfferReason } from './unavailable-offer-reason';

/**
 * Leaves the offer detail / store-locator modal stack and opens the offers tab
 * with the unavailable offer pinned for deeplink chrome.
 *
 * Offer detail lives under `(modals)/offers/[loyaltyEngineId]`. A plain
 * `replace('/offers')` from that stack often fails to resolve the tab screen
 * and drops the user on home; use typed `dismissTo` like menu unavailable.
 */
export function navigateToUnavailableOffersFeed(
  router: Pick<Router, 'canDismiss' | 'dismissTo' | 'replace'>,
  offerEngineId: string,
  reason?: UnavailableOfferReason
): void {
  const route = {
    pathname: routes.offers as '/offers',
    // `unavailableItemId` is the explicit recovery marker, mirroring menu
    // unavailable recovery. Without it the feed treats `offerEngineId` as an
    // ordinary deeplink and auto-opens the offer instead of pinning it.
    params: {
      offerEngineId,
      unavailableItemId: offerEngineId,
      ...(reason ? { unavailableReason: reason } : {}),
    },
  };

  if (router.canDismiss()) {
    router.dismissTo(route);
    return;
  }

  router.replace(route);
}
